import { TENURE_BAND_LABELS } from "@domains/reviews/shared/reviewee-filters/tenureBuckets.ts";
import type { LocalizedText } from "@packages/core/language/language.ts";
import { type CalibrationDimension, type ScoreBand, UNSET_GROUP_KEY } from "#shared/reviewScoresContract.ts";

export const REVIEWEE_COLUMN_LABELS = {
    displayName: { "en-US": "Person", "fr-CA": "Personne" },
    jobTitle: { "en-US": "Role", "fr-CA": "Rôle" },
    departmentLabel: { "en-US": "Department", "fr-CA": "Département" },
    performanceScore: { "en-US": "Performance", "fr-CA": "Performance" },
    potentialScore: { "en-US": "Potential", "fr-CA": "Potentiel" },
    overallScore: { "en-US": "Score", "fr-CA": "Score" }
} satisfies Record<string, LocalizedText>;

export const PERFORMANCE_BAND_LABELS: Record<ScoreBand, LocalizedText> = {
    Low: { "en-US": "Low", "fr-CA": "Faible" },
    Medium: { "en-US": "Medium", "fr-CA": "Moyenne" },
    High: { "en-US": "High", "fr-CA": "Élevée" }
};

export const POTENTIAL_BAND_LABELS: Record<ScoreBand, LocalizedText> = {
    Low: { "en-US": "Low", "fr-CA": "Faible" },
    Medium: { "en-US": "Medium", "fr-CA": "Moyen" },
    High: { "en-US": "High", "fr-CA": "Élevé" }
};

export const CALIBRATION_COLUMN_LABELS = {
    memberCount: { "en-US": "People", "fr-CA": "Personnes" },
    averageScore: { "en-US": "Avg", "fr-CA": "Moy." },
    spread: { "en-US": "Spread", "fr-CA": "Écart interne" },
    gap: { "en-US": "Gap", "fr-CA": "Écart" }
} satisfies Record<string, LocalizedText>;

export const CALIBRATION_DIMENSION_LABELS: Record<CalibrationDimension, LocalizedText> = {
    segment: { "en-US": "Segment", "fr-CA": "Segment" },
    manager: { "en-US": "Direct manager", "fr-CA": "Gestionnaire direct" },
    function: { "en-US": "Department", "fr-CA": "Département" },
    jobTitle: { "en-US": "Job title", "fr-CA": "Titre du poste" },
    tenure: { "en-US": "Tenure", "fr-CA": "Ancienneté" }
};

export const REVIEW_THEME_COLUMN_LABELS = {
    theme: { "en-US": "Theme", "fr-CA": "Thème" },
    category: { "en-US": "Category", "fr-CA": "Catégorie" },
    positive: { "en-US": "Positive", "fr-CA": "Positif" },
    mixed: { "en-US": "Mixed", "fr-CA": "Mitigé" },
    negative: { "en-US": "Negative", "fr-CA": "Négatif" },
    totalCount: { "en-US": "People reviewed", "fr-CA": "Personnes évaluées" }
} satisfies Record<string, LocalizedText>;

export const REVIEW_THEME_CATEGORY_LABELS = {
    strength: { "en-US": "Strength", "fr-CA": "Force" },
    opportunity: { "en-US": "Growth opportunity", "fr-CA": "Occasion de croissance" }
} satisfies Record<string, LocalizedText>;

export { REVIEW_THEME_NAME_LABELS } from "@domains/reviews/shared/reviewThemes.ts";

export const TENURE_BUCKET_LABELS: Record<string, LocalizedText> = {
    ...TENURE_BAND_LABELS,
    [UNSET_GROUP_KEY]: { "en-US": "Unknown", "fr-CA": "Inconnue" }
};
